import React, { useEffect, useState } from "react";
import { PageShell, PageHero, PageSection } from "../components/PageShell";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import AdminNav from "../components/AdminNav";
import { adminService } from "../services/adminService";
import FormModal from "../components/FormModal";
import { toast } from "sonner";

export default function AdminFaqsPage() {
  const [faqs, setFaqs] = useState([]);
  const [draft, setDraft] = useState({ question: "", answer: "" });
  const [error, setError] = useState("");
  const [addOpen, setAddOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  async function load() {
    const res = await adminService.listFaqs();
    if (!res.ok) {
      setError(res.error || "Failed to fetch FAQs");
      toast.error(res.error || "Failed to fetch FAQs");
      return;
    }
    setFaqs(res.data?.items || []);
  }
  useEffect(() => { load(); }, []);

  return (
    <PageShell>
      <PageHero eyebrow="Admin" title="FAQ" highlight="editor." description="Add, edit, and remove FAQ entries." />
      <PageSection variant="content">
        <div className="mx-auto max-w-7xl grid gap-6">
          <AdminNav />
          {error ? <Card><CardContent className="py-4 text-sm text-destructive">{error}</CardContent></Card> : null}
          <div><Button onClick={() => setAddOpen(true)}>Add FAQ</Button></div>
          {faqs.map((f) => (
            <Card key={f._id}>
              <CardHeader><CardTitle>{f.question}</CardTitle></CardHeader>
              <CardContent className="grid gap-3">
                <p className="text-sm text-muted-foreground">{f.answer}</p>
                <div className="flex gap-2">
                  <Button size="sm" variant="outline" onClick={() => { setEditing({ ...f }); setEditOpen(true); }}>Edit</Button>
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={async () => {
                      const r = await adminService.deleteFaq(f._id);
                      if (!r.ok) {
                        setError(r.error);
                        toast.error(r.error || "Delete failed");
                      } else {
                        toast.success("FAQ deleted");
                        await load();
                      }
                    }}
                  >
                    Delete
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </PageSection>
      <FormModal open={addOpen} title="Add FAQ" onClose={() => setAddOpen(false)}>
        <div className="grid gap-2">
          <input className="h-10 px-3 rounded-xl border border-border bg-background text-sm" placeholder="Question" value={draft.question} onChange={(e)=>setDraft((p)=>({...p,question:e.target.value}))}/>
          <textarea className="min-h-24 px-3 py-2 rounded-xl border border-border bg-background text-sm" placeholder="Answer" value={draft.answer} onChange={(e)=>setDraft((p)=>({...p,answer:e.target.value}))}/>
          <div>
            <Button
              size="sm"
              onClick={async () => {
                const r = await adminService.createFaq(draft);
                if (!r.ok) {
                  setError(r.error);
                  toast.error(r.error || "Create failed");
                } else {
                  toast.success("FAQ created");
                  setDraft({ question: "", answer: "" });
                  setAddOpen(false);
                  await load();
                }
              }}
            >
              Save FAQ
            </Button>
          </div>
        </div>
      </FormModal>
      <FormModal open={editOpen} title="Edit FAQ" onClose={() => setEditOpen(false)}>
        <div className="grid gap-2">
          <input className="h-10 px-3 rounded-xl border border-border bg-background text-sm" value={editing?.question || ""} onChange={(e)=>setEditing((p)=>({...(p||{}),question:e.target.value}))}/>
          <textarea className="min-h-24 px-3 py-2 rounded-xl border border-border bg-background text-sm" value={editing?.answer || ""} onChange={(e)=>setEditing((p)=>({...(p||{}),answer:e.target.value}))}/>
          <div>
            <Button
              size="sm"
              onClick={async () => {
                if (!editing?._id) return;
                const r = await adminService.updateFaq(editing._id, {
                  question: editing.question,
                  answer: editing.answer,
                  isPublished: editing.isPublished !== false,
                });
                if (!r.ok) {
                  setError(r.error);
                  toast.error(r.error || "Update failed");
                } else {
                  toast.success("FAQ updated");
                  setEditOpen(false);
                  await load();
                }
              }}
            >
              Update FAQ
            </Button>
          </div>
        </div>
      </FormModal>
    </PageShell>
  );
}

